import React, { useEffect, useState, useRef } from 'react';
import { Box, Button, Typography, Grid, IconButton } from '@mui/material';
import { ConstantActions } from '../../../Services/_actions/constant.actions.js';
import { ManagementActions } from '../../../Services/_actions/Management/management.actions.ts';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import DynamicBreadcrumbs from '../../Shared/Breadcrumb/index.tsx';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from 'react-router-dom';
import OrganisationDropdown from '../../Shared/OrganisationDropdown/index.tsx';

const RoleAssignment: React.FC = () => {
	const constantActions = ConstantActions();
	const managementActions = ManagementActions();
	const { showSnackBar } = useSnackBar();
	const navigate = useNavigate();

	const [organisationList, setOrganisationList] = useState([]);
	const [rolesList, setRolesList] = useState([]);
	const [selectedOrganisation, setSelectedOrganisation] = useState(null);
	const [parentRole, setParentRole] = useState(null);
	const [childRole, setChildRole] = useState(null);
	const [roleFilter, setRoleFilter] = useState({ organisationId: '', search: '', page: 1 });
	const [formErrors, setFormErrors] = useState({
		organisation: false,
	});

	// const breadcrumbsData = [
	//   { label: <IconButton color='primary'><HomeIcon /></IconButton>, onClick: () => navigate("/") },
	//   { label: 'Role Assignment' },
	// ];

	// useEffect(() => {
	//   constantActions.getOrganisationsWithPagination({ page: 1, search: '' })
	// 	.then(res => setOrganisationList(res.data?.list || []))
	// 	.catch(() => showSnackBar('Failed to load organisations', 'error'));
	// }, []);

	const handleOrganisationChange = (org: any) => {
		setSelectedOrganisation(org);
		setParentRole(null);
		setChildRole(null);
		setRoleFilter({ organisationId: org?.organisation_id, search: '', page: 1 });

		managementActions.getRoleList({ organisationId: org?.organisation_id, page: 1 })
			.then(res => setRolesList(res?.data?.list || []))
			.catch(() => showSnackBar('Failed to load roles', 'error'));
	};

	const handleSearchRole = (query: string) => {
		setRoleFilter(prev => ({ ...prev, search: query || '', page: 1 }));
		if (selectedOrganisation) {
			managementActions.getRoleList({ organisationId: selectedOrganisation.organisation_id, search: query, page: 1 })
				.then(res => setRolesList(res.data?.list || []))
				.catch(() => showSnackBar('Failed to search roles', 'error'));
		}
	};

	// const handleRoleAssignment = () => {
	//   if (!parentRole || !childRole) {
	// 	showSnackBar('Please select both parent and child roles', 'error');
	// 	return;
	//   }
	//   managementActions.assignRole({ parent: parentRole.id, child: childRole.id })
	// 	.then(() => showSnackBar('Role assigned successfully', 'success'))
	// 	.catch(() => showSnackBar('Failed to assign role', 'error'));
	// };

	const handleRoleAssignment = async () => {
		if (!selectedOrganisation) {
			setFormErrors(prev => ({ ...prev, organisation: true }));
			showSnackBar('Please select an organisation', 'error');
			return;
		} else {
			setFormErrors(prev => ({ ...prev, organisation: false }));
		}

		if (!parentRole || !childRole) {
			showSnackBar('Please select both parent and child roles', 'error');
			return;
		}

		const payload = {
			organisation: selectedOrganisation.organisation_id,
			parent: parentRole.id,
			child: childRole.id,
		};

		try {
			const res = await managementActions.assignRole(payload);
			if (res?.status === 200 && res.data === '') {
				showSnackBar('Role assigned successfully.', 'success');
				navigate(-1)

				// setParentRole(null);
				// setChildRole(null);
			} else {
				showSnackBar('Failed to assign role. Please try again.', 'error');
			}
		} catch (error) {
			showSnackBar('Failed to assign role. Please try again.', 'error');
		}
	};



	return (
		<Box p={3} maxWidth="900px" margin="auto" bgcolor="#f9f9f9" borderRadius={2} boxShadow={3}>
			{/* <DynamicBreadcrumbs items={breadcrumbsData} /> */}

			<Typography variant="h5" gutterBottom fontWeight="bold" textAlign="center">
				Role Assignment
			</Typography>

			<Grid container spacing={3}>
				<Grid item xs={12} sm={6}>
					{/* <SearchableDropdown
        	label="Select Organisation"
        	options={organisationList}
        	labelKey="name"
        	value={selectedOrganisation}
        	onChange={handleOrganisationChange}
        	placeholder="Choose organisation"
      	/> */}
					<OrganisationDropdown
						value={selectedOrganisation}
						onChange={handleOrganisationChange}
						label="Select Organisation"
						error={formErrors.organisation}
						errorMessage="Organisation is required"
					/>
				</Grid>

				<Grid item xs={12} sm={6} marginTop='13px'>
					<SearchableDropdown
						label="Select Parent Role"
						options={rolesList}
						labelKey="name"
						value={parentRole}
						onChange={setParentRole}
						onSearch={handleSearchRole}
						disabled={!selectedOrganisation}
					/>
				</Grid>

				<Grid item xs={12} sm={6}>
					<SearchableDropdown
						label="Select Child Role"
						options={rolesList}
						labelKey="name"
						value={childRole}
						onChange={setChildRole}
						onSearch={handleSearchRole}
						disabled={!selectedOrganisation}
					/>
				</Grid>

				<Grid item xs={12} display="flex" justifyContent="flex-end" gap={2}>
					<Button variant="outlined" size="small" onClick={() => {
						setSelectedOrganisation(null);
						setParentRole(null);
						setChildRole(null);
						navigate(-1);
					}}
					>
						Cancel
					</Button>
					<Button
						variant="contained"
						color="primary"
						size="small"
						onClick={handleRoleAssignment}
						disabled={!parentRole || !childRole}
					>
						Assign Role
					</Button>
				</Grid>
			</Grid>
		</Box>
	);
};

export default RoleAssignment;
